import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { DownloadListComponent } from "./download-list/download-list.component";

const routes: Routes = [
  {
    path: "downloads",
    component: DownloadListComponent,
    canActivate: [AuthGuard],
  },
];

export const DownloadsRoutes: ModuleWithProviders = RouterModule.forChild(
  routes
);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/downloads/downloads.routes.ts